import React from 'react';
import { Link } from 'react-router-dom';
import TableWrapper from '../elements/TableWrapper';
import img from './../../assets/img/At the office-pana 1.png';
import MiCompAPI from '../../util/api';
import moment from "moment";
import AddQuoteDrawer from './AddQuoteDrawer';
import EditQuote from './EditQuote';
import EditCarrierQuote from './EditCarrierQuote';
import {
    Layout, message, Row, Col, Modal,Spin
} from 'antd';
import FinalizedQuote from './FinalizedQuote';
const { Content } = Layout;
class Quote extends React.Component {
    constructor(props) {
        super(props);
        const { decodedToken } = this.props.userPermandMasters;
        var role = decodedToken.UserRoleName;
        if (role !== "carrier"&&role !== "agency") {
            this.columns = [{
                title: 'Quote Id',
                dataIndex: 'quote_Id',
                render: (text, record) => { return <Link onClick={() => this.UserDefaultHandlerEditQuote(text)}>{text}</Link> },
                sorter: (a, b) => a.quote_Id.localeCompare(b.quote_Id),
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Quote Name',
                dataIndex: 'quote_Name',
                sorter: (a, b) => a.quote_Name.localeCompare(b.quote_Name),
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Submitted On',
                dataIndex: 'submitted_on',
                sorter: (a, b) => new Date(a.submitted_on) - new Date(b.submitted_on),
                render: (text, record) =>
                    record["submitted_on"] !== null && record["submitted_on"] !== ""
                        ? moment(record["submitted_on"]).format("MM/DD/YYYY")
                        : "",
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Finalized On',
                dataIndex: 'finalized_on',
                sorter: (a, b) => new Date(a.finalized_on) - new Date(b.finalized_on),
                render: (text, record) =>
                    record["finalized_on"] !== null && record["finalized_on"] !== ""
                        ? moment(record["finalized_on"]).format("MM/DD/YYYY")
                        : "",
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Quote Status',
                dataIndex: 'quote_Status',
                sorter: (a, b) => a.quote_Status.localeCompare(b.quote_Status),
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Policy Number',
                dataIndex: 'policy_No',
                sorter: (a, b) => a.policy_No.localeCompare(b.policy_No),
                sortDirections: ["descend", "ascend"]
            }];
        }
        else {
            this.columns = [{
                title: 'Quote Id',
                dataIndex: 'quote_Id',
                render: (text, record) => { return <Link onClick={() => this.UserDefaultHandlerEditQuote(text)}>{text}</Link> },
                sorter: (a, b) => a.quote_Id.localeCompare(b.quote_Id),
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Quote Name',
                dataIndex: 'quote_Name',
                sorter: (a, b) => a.quote_Name.localeCompare(b.quote_Name),
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Submitted On',
                dataIndex: 'submitted_on',
                sorter: (a, b) => new Date(a.submitted_on) - new Date(b.submitted_on),
                render: (text, record) =>
                    record["submitted_on"] !== null && record["submitted_on"] !== ""
                        ? moment(record["submitted_on"]).format("MM/DD/YYYY")
                        : "",
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Finalized On',
                dataIndex: 'finalized_on',
                sorter: (a, b) => new Date(a.finalized_on) - new Date(b.finalized_on),
                render: (text, record) =>
                    record["finalized_on"] !== null && record["finalized_on"] !== ""
                        ? moment(record["finalized_on"]).format("MM/DD/YYYY")
                        : "",
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Producer Name',
                dataIndex: 'producer',
                sorter: (a, b) => a.producer.localeCompare(b.producer),
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Quote Status',
                dataIndex: 'quote_Status',
                sorter: (a, b) => a.quote_Status.localeCompare(b.quote_Status),
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Policy Number',
                dataIndex: 'policy_No',
                // sorter: (a, b) => a.policy_No.localeCompare(b.policy_No),
                sortDirections: ["descend", "ascend"]
            }];
        }
        this.state = {
            quotes: [],
            isloading: false,
            AddQuoteActive: false,
            IsEditQuote: false,
            quote: null,
            isFinalize: false
        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }

    componentDidMount() {
        this.getQuotes();
    }
    getQuotes = () => {
        this.setState({
            isloading: true
        });
        this.api.invoke(
            "GetQuotes",
            "get",
            (data, success) => {
                if (success) {
                    this.setState({
                        quotes: data.data,
                        isloading: false
                    });
                }
            },
        );
    }
    UserDefaultHandlerEditQuote = (quote_id) => {

        this.setState({
            IsEditQuote: !this.state.IsEditQuote,
            isloading:true,
        })
        setTimeout(() => {
            if (this.state.IsEditQuote) {
                this.api.invoke(
                    "GetQuotebyId/" + quote_id,
                    "get",
                    (data, success) => {
                        if (success) {
                            this.setState({
                                quote: data.data,
                                isloading:false

                            });
                        }
                    },
                );
            } else {
                this.getQuotes();

            }
        }, 1);

    }
    UserDefaultHandler = () => {
        this.setState({
            AddQuoteActive: !this.state.AddQuoteActive
        })
    }
    addSubmitHandler = (values) => {
        this.setState({
            isloading: true
        });
        this.api.invoke("SaveQuote", "post", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    message.destroy();
                    message.success(data.statusMessage, 3);
                    this.UserDefaultHandler();
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
                this.getQuotes();
            }
            else {
                message.destroy();
                message.error("Failed . Contact Support", 3);
            }
            this.setState({
                isloading: false
            });
        }, values);
    }
    UpdateQuoteByUser = (values) => {
        this.api.invoke("UpdatePolicy_No", "post", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    message.destroy();
                    message.success(data.statusMessage, 3);
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
                this.UserDefaultHandlerEditQuote(this.state.quote.id);
            }
            else {
                message.destroy();
                message.error("Failed . Contact Support", 3);
            }
        }, values);
    }
    UpdateQuoteByCarrier = (values) => {
        this.api.invoke("UpdateQuoteByCarrier", "post", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    message.destroy();
                    message.success(data.statusMessage, 3);
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
                this.UserDefaultHandlerEditQuote(this.state.quote.id);
            }
            else {
                message.destroy();
                message.error("Failed . Contact Support", 3);
            }
        }, values);
    }
    handleSubmitFinalize = (e) => {

        this.api.invoke("FinalizeQuote/" + this.state.quote.id + "/" + (e === 0 ? e : e.carrier), "post", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {

                    message.destroy();
                    message.success(data.statusMessage, 3);
                    this.UserDefaultHandlerEditQuote(this.state.quote.id);
                    this.setState({
                        isFinalize: false
                    });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
                this.getQuotes();
            }
            else {
                message.destroy();
                message.error("Failed . Contact Support", 3);
            }
        });


    }
    render() {
        const { decodedToken } = this.props.userPermandMasters;
        var role = decodedToken.UserRoleName;
        this.tableButtons = [];
        if (role === "broker")
            this.tableButtons.push({
                buttonType: "primary",
                content: "Create Quote",
                clickHandler: () => {
                    this.UserDefaultHandler();
                },
            })
        return (
            <Content>
                {this.state.isFinalize ? (
                    <Modal visible={this.state.isFinalize}  >
                        <FinalizedQuote submitHandler={this.handleSubmitFinalize} closeDrawerHandler={() => this.setState({ isFinalize: false })} title="Finalize Quote" quote={this.state.quote}></FinalizedQuote>
                    </Modal>

                ) : null}
                {this.state.AddQuoteActive ? (
                    <Modal
                        visible={this.state.AddQuoteActive}
                    >
                        <AddQuoteDrawer
                            closeDrawerHandler={this.UserDefaultHandler}
                            submitHandler={this.addSubmitHandler}
                            width={500}
                            address_types={this.state.address_types}
                            states={this.state.states}
                            userPermandMasters={this.props.userPermandMasters}
                            title="Enter New Quote"
                        />
                    </Modal>
                ) : null}
                {!this.state.IsEditQuote ?
                    <div className="mi_main1">
                        <div className="mi_box">
                            <Row span={24}>
                                <Col span={18}>
                                    <h4 className="mi_box_h4">Quotes</h4>
                                </Col>
                                <Col span={6}>
                                    <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
                                </Col>
                            </Row>
                        </div>
                        <TableWrapper columns={this.columns} rowKey="id" data={this.state.isloading ? null : this.state.quotes} loading={this.state.isloading} buttons={this.tableButtons} title="All Quotes" search={true} />
                    </div>
                    : <div >
                        {this.state.isLoading ?
                        <div className="mi_main">
                            <Spin size="large" >
                                <div style={{ textAlign: "center", marginTop: "150px" }}>
                                    <h2>Loading. Please wait...</h2>
                                </div>
                            </Spin></div>:     
    
                        this.state.quote ?
                            <div className="mi_main">
                                {role !== "carrier" ?
                                    <EditQuote FinalizeHandler={() => this.setState({ isFinalize: true })} quote={this.state.quote} title="Edit Quote" style={{ marginTtop: '-28px', marginLeft: '-29px' }} closeDrawerHandler={() => this.UserDefaultHandlerEditQuote('')} submitHandler={this.UpdateQuoteByUser} userPermandMasters={this.props.userPermandMasters}></EditQuote>
                                    : <EditCarrierQuote FinalizeHandler={() => this.handleSubmitFinalize(0)} quote={this.state.quote} title="Edit Quote" closeDrawerHandler={() => this.UserDefaultHandlerEditQuote('')} submitHandler={this.UpdateQuoteByCarrier} userPermandMasters={this.state.userPermandMasters}></EditCarrierQuote>}</div> :  <div className="mi_main">
                                    <Spin size="large" >
                                        <div style={{ textAlign: "center", marginTop: "150px" }}>
                                            <h2>Loading. Please wait...</h2>
                                        </div>
                                    </Spin></div>}
                    </div>}
            </Content>
        );
    }
}
export default Quote;